import { TYPE_DATE_COMPARISON } from './input-types';

export const id = 'datePaid';
export const apiKey = 'PaidDateTime';
export const type = TYPE_DATE_COMPARISON;

export const datePaid = {
  id,
  apiKey,
  type,
};
